export default {
  relatedCourses: []
};
